import { useEffect, useState } from 'react';

/** Valor con retardo: lo que se escribe en un buscador llega al servidor cuando la persona deja de teclear. */
export function useDebounced<T>(value: T, ms = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return debounced;
}
